// getFormUrl(formId, taskId, defaultFormView)
// defaultFormView: 0 = test-form, 1 = form
// Priority: localStorage override > company default
export function getFormUrl(formId, taskId, defaultFormView) {
  // Check if user manually set a preference in localStorage
  const localPref = localStorage.getItem("use_new_form");
  let useNewVersion;

  if (localPref !== null) {
    // User has a manual preference
    useNewVersion = localPref === "true";
  } else {
    // Use company default
    useNewVersion = defaultFormView === 1;
  }

  const route = useNewVersion ? "form" : "test-form";
  return `/#/${route}?f=${formId}&t=${taskId}`;
}
